(function(){
  function init(root){
    var wrap  = root.querySelector('.trip-music'); if(!wrap) return;
    var audio = wrap.querySelector('#trip-audio');
    var btn   = wrap.querySelector('#trip-toggle');
    var icon  = wrap.querySelector('#trip-icon');

    function ui(playing){
      wrap.classList.toggle('playing', playing);
      if(!icon) return;
      icon.innerHTML = playing
        ? '<rect x="6" y="5" width="4" height="14"></rect><rect x="14" y="5" width="4" height="14"></rect>' // pause
        : '<path d="M8 5v14l11-7z"></path>'; // play
    }

    async function tryPlay(){
      try { await audio.play(); ui(true); return true; }
      catch(e){ ui(false); return false; } // autoplay blocked
    }

    // Click → play/pause
    btn && btn.addEventListener('click', async function(){
      if(audio.paused){ await tryPlay(); } else { audio.pause(); ui(false); }
    });

    // Autoplay + fallback on first interaction
    var wantAutoplay = wrap.getAttribute('data-autoplay') === 'true';
    if(wantAutoplay){
      tryPlay().then(function(ok){
        if(ok) return;
        var kick = async function(){
          await tryPlay();
          window.removeEventListener('scroll', kick, {passive:true});
          window.removeEventListener('touchstart', kick);
          window.removeEventListener('click', kick);
        };
        window.addEventListener('scroll', kick, {passive:true});
        window.addEventListener('touchstart', kick);
        window.addEventListener('click', kick);
      });
    }
  }

  // Theme editor + storefront
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:section:select', function(e){ init(e.target); });
})();
